module.exports = "/images/favicon-16x16.png?4bb435a";


//////////////////
// WEBPACK FOOTER
// ./resources/img/favicon/favicon-16x16.png
// module id = 23
// module chunks = 0